(function() {

/* 
     * BLOXException handler
     *
     * @listens BLOXException
     * @event dataLayer#Application Exception
     */
    window.addEventListener('BLOXException', function(ev) {
        if (window.dataLayer && ev.detail) {
            dataLayer.push({
                'event': 'Application Exception',
                'properties': ev.detail
            });
        }
    });

})();